'use client';

import {usePathname} from 'next/navigation';
import {useEffect} from 'react';

import {analytics} from '@/lib/analytics';

export default function AnalyticsPageview() {
  const pathname = usePathname();

  useEffect(() => {
    if (analytics) {
      analytics.page();
    } else {
      console.log('Analytics not defined. Would have sent pageview:', pathname);
    }
  }, [pathname]);

  return null;
}
